import { TickSquare } from 'iconsax-react';

import classes from './ContentRequirments.module.scss';

const ContentRequirments = () => {
	return (
		<div className={`${classes['content-requirments-wrapper']} d-flex flex-column gap-3`}>
			<h3>Requirements</h3>
			{/* <p>
				University Teaching is an introductory course in teaching and learning in tertiary
				education, designed by staff at the
			</p> */}
			<ul className="d-flex flex-column gap-3">
				<li>
					<TickSquare color="#0d0d0d" variant="TwoTone" />
					No previous experience necessary
				</li>
				<li>
					<TickSquare color="#0d0d0d" variant="TwoTone" />
					Access to a mobile phone, personal computer or equivalent
				</li>
				<li>
					<TickSquare color="#0d0d0d" variant="TwoTone" />
					Internet connection
				</li>
			</ul>
		</div>
	);
};

export default ContentRequirments;
